import { IS_TOKEN_FROM_COOKIES } from "@saleor/config";
import { setContext } from "apollo-link-context";
import { ErrorResponse, onError } from "apollo-link-error";

import {
  getTokenCookies,
  getTokens,
  removeTokenCookies,
  removeTokens
} from "./";
import { isJwtError, JWTError } from "./errors";

const MFA_APP_KEY = process.env.MFA_APP_KEY;

interface ResponseError extends ErrorResponse {
  networkError?: Error & {
    statusCode?: number;
    bodyText?: string;
  };
}

export const invalidateTokenLink = onError((error: ResponseError) => {
  if (
    (error.networkError && error.networkError.statusCode === 401) ||
    error.graphQLErrors?.some(isJwtError)
  ) {
    if (error.graphQLErrors[0].extensions.code !== JWTError.expired) {
      removeTokens();
      removeTokenCookies();
    }
  }
});

export const tokenLink = setContext((_, context) => {
  const authToken = IS_TOKEN_FROM_COOKIES
    ? getTokenCookies().auth
    : getTokens().auth;

  return {
    ...context,
    headers: {
      ...context.headers,
      Authorization: authToken ? `JWT ${authToken}` : null,
      "X-MFA-APP-KEY": MFA_APP_KEY
    }
  };
});

const link = invalidateTokenLink.concat(tokenLink);

export default link;
